import { render, staticRenderFns } from "./IconBetaOpenInNew.vue?vue&type=template&id=7024980b&"
import script from "./IconBetaOpenInNew.vue?vue&type=script&lang=ts&"
export * from "./IconBetaOpenInNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports